import { Map, fromJS } from 'immutable';
import { combineReducers } from 'redux-immutable';
import { LOCATION_CHANGE } from 'react-router-redux';
import { LOGOUT_SUCCESS } from './containers/Auth/constants';

// reducers
import auth from './containers/Auth/reducer';
import statistics from './containers/Statistics/reducer';
import settings from './containers/Settings/reducer';
import paymentInfo from './containers/PaymentInfo/reducer';
import dashboard from './pages/DashboardPage/reducer';

const routeInitialState = fromJS({
  locationBeforeTransitions: null,
});

/**
 * Merge route into the global application state
 *
 * @param {any} state The current state
 * @param {Object} action A plain object representing `what changed`
 * @return {any} The new state
 */
function routeReducer(state = routeInitialState, action) {
  switch (action.type) {
    case LOCATION_CHANGE:
      return state.merge({
        locationBeforeTransitions: action.payload,
      });
    default:
      return state;
  }
}

/**
 * Creates the main reducer with the asynchronously loaded ones
 *
 * @param {Object} asyncReducers Async reducer registry
 * @return {Function} A function that when invoked, will call all our reducers
 */
export default function createReducer(asyncReducers) {
  const appReducer = combineReducers({
    route: routeReducer,
    auth,
    statistics,
    settings,
    paymentInfo,
    dashboard,
    ...asyncReducers,
  });

  return (state, action) => {
    const authRequired =
      action.errorMessage && action.errorMessage.error_code === 'AUTH_REQUIRED';
    if (action.type === LOGOUT_SUCCESS || authRequired) {
      // eslint-disable-next-line
      state = new Map();
    }
    return appReducer(state, action);
  };
}



// WEBPACK FOOTER //
// ./src/reducers.js